import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges } from '@angular/core';
import { RequestService } from '@df/api/request/request.service';
import { StoreResource } from '@df/catalog/store/store.resource';
import { Status } from '@df/core/status';
import { OrdinalPipe } from '@df/ui/display/ordinal.pipe';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { StoreDecorator } from './../../catalog/model/store/store.decorator';
import { CheckoutFormComponent } from './../checkout-form.component';
import { MetapackCollectionPoint } from './metapack/metapack-collection-point';
import { MetapackService } from './metapack/metapack.service';

@Component({
    selector: 'checkout-collection-status',
    templateUrl: './checkout-collection-status.html',
    standalone: true,
    imports: [CommonModule, OrdinalPipe, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutCollectionStatusComponent implements OnChanges {
    status = new Status();
    model?: StoreDecorator | MetapackCollectionPoint;

    @Input()
    storeId?: number;

    @Input()
    bookingCode?: string;

    constructor(
        protected checkoutFormComponent: CheckoutFormComponent,
        protected storeResource: StoreResource,
        protected metapack: MetapackService,
        protected changeDetectorRef: ChangeDetectorRef,
        protected request: RequestService
    ) {}

    ngOnChanges() {
        this.model = undefined;
        if (this.status.promise?.cancel) {
            this.status.promise.cancel();
        }

        if (this.bookingCode) {
            const cp = this.metapack.get(this.bookingCode);
            if (cp) {
                this.model = cp;
            } else {
                const additionalData = this.checkoutFormComponent.getAdditionalShippingData();
                if (additionalData) {
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    const { booking_code, postcode, country_id } = additionalData;

                    if (booking_code && postcode && country_id) {
                        this.metapack.findOne(
                            this.status,
                            { booking_code, postcode, country_id },
                            (collectionPoints: MetapackCollectionPoint[]) => {
                                if (collectionPoints?.length) {
                                    this.model = collectionPoints[0];
                                    this.detectChanges();
                                }
                            }
                        );
                    }
                }
            }
        } else if (this.storeId) {
            this.request.send(
                this.status,
                () => this.storeResource.load(this.storeId, 3),
                () => {
                    if (this.storeId) {
                        this.model = this.storeResource.getExisting(this.storeId) as StoreDecorator;
                        this.detectChanges();
                    }
                }
            );
        }
    }

    get secondLine(): string {
        return this.model?.secondLine;
    }

    get leadTime(): string | undefined {
        return this.checkoutFormComponent?.shippingMethod?.lead_time;
    }

    protected detectChanges(): void {
        this.changeDetectorRef.detectChanges();
    }
}
